import React from 'react';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
  logoText: {
    /* Targets displays using the Windows' "High Contrast" theme: */
    '@media screen and (forced-colors: active)': {
      fill: '#646464 !important',
    },
  },
});

export const LogoImage = React.memo((props) => {
  const classes = useStyles();
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 337.6 72"
      enableBackground="new 0 0 337.6 72"
      {...props}
    >
      <path
        className={classes.logoText}
        fill="#646464"
        d="M140.3,14.4v43.2h-7.5V23.8h-0.1l-13.4,33.9h-5l-13.7-33.9h-0.1v33.9h-6.9V14.4h10.8l12.4,32h0.2l13.1-32H140.3
        L140.3,14.4z M146.6,17.7c0-1.2,0.4-2.2,1.3-3c0.9-0.8,1.9-1.2,3.1-1.2c1.3,0,2.4,0.4,3.2,1.3s1.3,1.8,1.3,3s-0.4,2.2-1.3,3
        c-0.9,0.8-1.9,1.2-3.2,1.2s-2.3-0.4-3.1-1.2C147,19.9,146.6,18.9,146.6,17.7z M154.6,26.7v31h-7.3v-31
        C147.3,26.7,154.6,26.7,154.6,26.7z M176.8,52.3c1.1,0,2.3-0.3,3.6-0.8s2.5-1.2,3.6-2v6.8c-1.2,0.7-2.5,1.2-4,1.5s-3.1,0.5-4.9,0.5
        c-4.6,0-8.3-1.4-11.1-4.3c-2.9-2.9-4.3-6.6-4.3-11c0-5,1.5-9.1,4.4-12.3s7-4.8,12.4-4.8c1.4,0,2.8,0.2,4.1,0.5
        c1.4,0.4,2.5,0.8,3.3,1.2v7c-1.1-0.8-2.3-1.5-3.4-1.9c-1.1-0.4-2.4-0.7-3.6-0.7c-2.9,0-5.2,0.9-7,2.8s-2.6,4.4-2.6,7.6
        c0,3.1,0.9,5.6,2.6,7.3C171.5,51.5,173.8,52.3,176.8,52.3z M204.7,26.1c0.6,0,1.1,0,1.6,0.1s0.9,0.2,1.2,0.3v7.4
        c-0.4-0.3-0.9-0.5-1.7-0.8s-1.6-0.4-2.7-0.4c-1.8,0-3.3,0.8-4.5,2.3s-1.9,3.8-1.9,7v15.6h-7.3v-31h7.3v4.9h0.1c0.7-1.7,1.7-3,3-4
        C201.2,26.6,202.8,26.2,204.7,26.1L204.7,26.1z M207.8,42.6c0-5.1,1.4-9.2,4.3-12.2s6.9-4.5,12.1-4.5c4.8,0,8.6,1.4,11.3,4.3
        s4.1,6.8,4.1,11.7c0,5-1.4,9-4.3,12c-2.9,3-6.8,4.5-11.8,4.5c-4.8,0-8.6-1.4-11.4-4.2C209.3,51.3,207.8,47.5,207.8,42.6z
        M215.4,42.4c0,3.2,0.7,5.7,2.2,7.4s3.6,2.6,6.3,2.6c2.6,0,4.7-0.8,6.1-2.6c1.4-1.7,2.1-4.2,2.1-7.6c0-3.3-0.7-5.8-2.1-7.5
        c-1.4-1.7-3.4-2.5-6-2.5c-2.7,0-4.7,0.9-6.2,2.7C216.2,36.5,215.4,39.1,215.4,42.4L215.4,42.4z M250.5,34.8c0,1,0.3,1.9,1,2.5
        s2.1,1.3,4.4,2.2c2.9,1.2,5,2.5,6.1,3.9c1.2,1.5,1.8,3.2,1.8,5.3c0,2.9-1.1,5.3-3.4,7s-5.3,2.7-9.1,2.7c-1.3,0-2.7-0.2-4.3-0.5
        s-2.9-0.7-4-1.2v-7.2c1.3,0.9,2.8,1.7,4.3,2.2s2.9,0.8,4.2,0.8c1.7,0,2.9-0.2,3.7-0.7s1.2-1.2,1.2-2.3c0-1-0.4-1.8-1.2-2.5
        s-2.4-1.5-4.6-2.4c-2.7-1.1-4.6-2.4-5.7-3.8c-1.1-1.4-1.7-3.2-1.7-5.4c0-2.8,1.1-5.1,3.3-6.9c2.2-1.8,5.1-2.7,8.6-2.7
        c1.1,0,2.3,0.1,3.6,0.4c1.4,0.2,2.5,0.5,3.4,0.9v7c-1-0.6-2.1-1.2-3.4-1.7c-1.3-0.5-2.6-0.7-3.8-0.7c-1.4,0-2.5,0.3-3.2,0.8
        C250.9,33.1,250.5,33.9,250.5,34.8L250.5,34.8z M266.9,42.6c0-5.1,1.5-9.2,4.3-12.2c2.9-3,6.9-4.5,12-4.5c4.8,0,8.6,1.4,11.3,4.3
        s4.1,6.8,4.1,11.7c0,5-1.5,9-4.3,12c-2.9,3-6.8,4.5-11.8,4.5c-4.8,0-8.6-1.4-11.4-4.2C268.3,51.3,266.9,47.5,266.9,42.6L266.9,42.6z
        M274.5,42.4c0,3.2,0.7,5.7,2.2,7.4s3.6,2.6,6.3,2.6c2.6,0,4.7-0.8,6.1-2.6c1.4-1.7,2.1-4.2,2.1-7.6c0-3.3-0.7-5.8-2.1-7.5
        s-3.5-2.5-6-2.5c-2.7,0-4.7,0.9-6.2,2.7C275.2,36.5,274.5,39.1,274.5,42.4L274.5,42.4z M322.9,32.6H312v25h-7.4v-25h-5.2v-6h5.2
        v-4.3c0-3.3,1.1-5.9,3.2-8s4.8-3.1,8.1-3.1c0.9,0,1.7,0.1,2.4,0.1s1.3,0.2,1.8,0.4v6.4c-0.2-0.1-0.7-0.3-1.3-0.5
        c-0.6-0.2-1.3-0.3-2.1-0.3c-1.5,0-2.7,0.5-3.5,1.4c-0.8,1-1.2,2.4-1.2,4.2v3.7h10.9v-7l7.3-2.2v9.2h7.4v6h-7.4v14.5
        c0,1.9,0.4,3.3,1,4c0.7,0.8,1.8,1.2,3.3,1.2c0.4,0,0.9-0.1,1.5-0.3s1.1-0.4,1.5-0.7v6c-0.5,0.3-1.2,0.5-2.3,0.7s-2.1,0.3-3.2,0.3
        c-3.1,0-5.4-0.8-6.9-2.5c-1.5-1.6-2.3-4.1-2.3-7.4L322.9,32.6L322.9,32.6z"
      />
      <path fill="#F25022" d="M0,0h34.2v34.2H0V0z" />
      <path fill="#7FBA00" d="M37.8,0H72v34.2H37.8V0z" />
      <path fill="#00A4EF" d="M0,37.8h34.2V72H0V37.8z" />
      <path fill="#FFB900" d="M37.8,37.8H72V72H37.8V37.8z" />
    </svg>
  );
});

LogoImage.propTypes = {};
